import { FC, useEffect } from "react";
import { useHomeSearchSettingsContext } from "@pages/Home/HomeContext";
import { useSelectAmongContext } from "@vms/SelectAmong/SelectAmongContext";
import { AMONG_VIEWS } from "@pages/Home/useSettingsSummary";

const HomeAmongSettingsApplier: FC = () => {
    const { data } = useHomeSearchSettingsContext();
    const { setPartial } = useSelectAmongContext();

    useEffect(() => {
        if (data?.among && AMONG_VIEWS.includes(data?.viewAs)) {
            setPartial(data.among);
        }
    }, [data, setPartial]);

    return null;
}

export default HomeAmongSettingsApplier;